module.exports = __webpack_public_path__ + "b441e1285ab72dbb4efb0c7fe46702b2.png";